<div class="welcome-container container-fluid d-flex align-items-center justify-content-center px-3 px-sm-4">
  <div class="row welcome-row gx-0 w-100 justify-content-center">
    <div class="col-12 col-sm-10 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
      <div
        *ngIf="installGuideVisible && installGuideReady && mobilePlatform === 'ios'"
        class="install-guide safari-guide"
        role="dialog"
        aria-labelledby="ios-install-title"
      >
        <div class="install-guide-icon" aria-hidden="true">
          <mat-icon>add_to_home_screen</mat-icon>
        </div>
        <h1 id="ios-install-title">Install CHEF on your iPhone or iPad</h1>
        <p class="install-guide-intro">Add CHEF to your Home Screen for quick, app-like access.</p>
        <ng-container [ngSwitch]="iosBrowser">
          <ol *ngSwitchCase="'edge'" class="install-steps text-start">
            <li>In Microsoft Edge, tap the <strong>three-dot menu</strong> at the bottom.</li>
            <li>Tap <strong>Share</strong>, then select <strong>Add to Home Screen</strong>.</li>
            <li>If you do not see it, scroll through the share actions and tap <strong>Add to Home Screen</strong>.</li>
            <li>Tap <strong>Add</strong>, then open CHEF from your Home Screen.</li>
          </ol>
          <ol *ngSwitchDefault class="install-steps text-start">
            <li>Tap the browser's <strong>Share</strong> button.</li>
            <li>Scroll through the share actions and select <strong>Add to Home Screen</strong>.</li>
            <li>Tap <strong>Add</strong>, then open CHEF from your Home Screen.</li>
          </ol>
        </ng-container>
        <button
          mat-raised-button
          type="button"
          (click)="continueInBrowser()"
          class="btn-color-CamRed install-continue-button"
        >
          Continue in browser
        </button>
      </div>

      <div
        *ngIf="installGuideVisible && installGuideReady && mobilePlatform === 'android'"
        class="install-guide android-guide"
        role="dialog"
        aria-labelledby="android-install-title"
      >
        <div class="install-guide-icon" aria-hidden="true">
          <mat-icon>install_mobile</mat-icon>
        </div>
        <ng-container *ngIf="installedAppAvailable; else androidInstallGuide">
          <h1 id="android-install-title">Use the CHEF app</h1>
          <p class="install-guide-intro">
            CHEF is already installed on this device. Open CHEF from your Home screen or tap
            <strong>Open in app</strong> in your browser for the best experience.
          </p>
          <button mat-raised-button type="button" (click)="continueInBrowser()" class="btn-color-CamRed install-button">
            Continue in browser
          </button>
        </ng-container>
        <ng-template #androidInstallGuide>
          <h1 id="android-install-title">Install CHEF</h1>
          <p class="install-guide-intro">Install CHEF on your Android device for a faster, app-like experience.</p>
          <button
            *ngIf="androidInstallAvailable"
            mat-raised-button
            type="button"
            (click)="installApp()"
            class="btn-color-CamRed install-button"
          >
            Install CHEF
          </button>
          <p *ngIf="androidMenuInstructionsVisible || !androidInstallAvailable" class="install-help-text">
            Open CHEF in a regular browser window, not an Incognito or InPrivate window. Then tap your browser menu and
            choose <strong>Install app</strong> or <strong>Add to Home screen</strong>.
          </p>
          <button mat-button type="button" (click)="continueInBrowser()" class="install-continue-button">
            Continue in browser
          </button>
        </ng-template>
      </div>

      <div *ngIf="!installGuideVisible" class="login-box">
        <div class="logo-section">
          <mat-icon class="app-icon" [svgIcon]="'chefLogo'"></mat-icon>
          <h1>CHEF</h1>
        </div>
        <p class="welcome-text">Please sign in to continue</p>
        <button mat-raised-button (click)="login()" class="btn-color-CamRed sign-in-button">
          <mat-icon>login</mat-icon>
          Sign In
        </button>
        <p *ngIf="settingsError" class="settings-error-text">
          <mat-icon class="error-icon">error_outline</mat-icon>
          <span>Unable to connect to the server.</span>
        </p>
      </div>
    </div>
  </div>
</div>
